import styled from 'styled-components'
import chartIcon from 'assets/icons/chart.png'

export const ChartsWrapper = styled.div`
  width: 100vw;
  margin: 10px 0;
`

export const ChartBlock = styled.div`
  position: relative;
  margin: 10px auto;
  width: 100%;
  height: 600px;
`

export const ChartButtons = styled.div`
  display: flex;
  //justify-content: center;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.white33};
  padding-top: 10px;
  width: 100%;
`

export const ChartButtonBlock = styled.div<{ colColor: string }>`
  display: flex;
  align-items: center;
  margin: 3px 10px 0;
  color: ${({ colColor }) => colColor};
`

export const LoaderWrapper = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  margin-left: 40px;
`

export const LegendBlock = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 10;
`

export const LegendRow = styled.div``

export const LegendTitle = styled.div<{ colorByKey: string }>`
  color: ${({ colorByKey }) => colorByKey};
`

export const ChartIcon = styled.div<{ opened?: boolean }>`
  width: 22px;
  height: 22px;
  opacity: 0.8;
  background: url(${chartIcon});
  background-position: center;
  background-size: contain;
  border: 1px solid ${({ theme, opened }) => (opened ? theme.yellow : '#ffffff00')};
  border-radius: 3px;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`
